import React from "react";
import { Mail, MapPin, Phone } from "lucide-react";

function MainFooter() {
  return (
    <div className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <img
                src="/logo.png"
                alt="Гостим"
                className="w-10 h-10 object-contain"
              />

              <span className="text-xl font-bold">Гостим</span>
            </div>
            <p className="text-gray-400">
              Сервис для лучшего гостеприимства. Автоматизируйте управление
              отелем и увеличивайте доход.
            </p>
          </div>

          {/* Products */}
          <div className="mob_hide"></div>
          {/* Company */}
          <div className="mob_hide"></div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold mb-4">Контакты</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-gray-400">
                <Mail className="w-4 h-4" />
                <span>
                  <a href="mailto:support@gostim.ru">support@gostim.ru</a>
                </span>
              </li>
              <li className="flex items-center gap-3 text-gray-400">
                <Phone className="w-4 h-4" />
                <span>
                  <a href="tel:+79099125113">+7 (909) 912-51-13</a>
                </span>
              </li>
              <li className="flex items-center gap-3 text-gray-400">
                <MapPin className="w-4 h-4" />
                <span>Москва, Россия</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} Гостим. Все права защищены.
          </p>
          <div className="flex gap-6 text-sm">
            <a
              href={"/pages/privacy"}
              className="text-gray-500 hover:text-white transition-colors"
            >
              Политика конфиденциальности
            </a>
            <a
              href={"/pages/offer"}
              className="text-gray-500 hover:text-white transition-colors"
            >
              Пользовательское соглашение
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MainFooter;
